import { Typography } from "@/components";
import AssignmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";
import ForumTwoToneIcon from "@mui/icons-material/ForumTwoTone";
import Button from "@mui/material/Button";
import type React from "react";

interface EmptyCaseProps {
	type?: "list" | "chat";
	title?: string;
	addLabel?: string;
	onClickAdd?: React.MouseEventHandler<HTMLButtonElement>;
}

const EmptyCase = (props: EmptyCaseProps) => {
	const {
		type = "list",
		title = "Add cases for real time patient management",
		addLabel,
		onClickAdd,
	} = props;

	const Icon = type === "list" ? AssignmentTwoToneIcon : ForumTwoToneIcon;

	return (
		<div className="h-full flex flex-col justify-center items-center gap-3">
			<div className="bg-white p-5 rounded-[3rem]">
				<Icon className="!text-[5rem] !text-zinc-500" />
			</div>
			<Typography fontWeight={700} fontSize={16}>
				{title}
			</Typography>
			{onClickAdd && addLabel ? (
				<Button
					variant="contained"
					color="primary"
					className="!h-12 !rounded-full"
					onClick={onClickAdd}
				>
					{addLabel}
				</Button>
			) : null}
		</div>
	);
};

export default EmptyCase;
